<button [class]="cssClass" [matButton]="matButtonType" matRipple>
  @if (leadingIcon()) {
    <mat-icon>{{ leadingIcon() }}</mat-icon>
  }
  {{ text() }}
  @if (trailingIcon()) {
    <mat-icon iconPositionEnd>{{ trailingIcon() }}</mat-icon>
  }
</button>
